/* eslint-disable no-restricted-globals */
/* eslint-disable no-use-before-define */
/* eslint-disable no-undef */
const playlistsData = JSON.parse(document.querySelector('[data-playlists]').innerHTML) || [];
let selectedList;
let selectedTrackIdx = 0;
// load sound via <audio> tag
const audioElement = document.querySelector('audio');
let audioCtx;
if (typeof AudioContext === 'function') {
  audioCtx = new AudioContext();
} else if (typeof webkitAudioContext === 'function') {
  // eslint-disable-next-line new-cap
  audioCtx = new webkitAudioContext();
} else {
  console.info('The Web Audio API is not supported in your browser');
}
let analyser = audioCtx.createAnalyser();
let source = audioCtx?.createMediaElementSource(audioElement);

// Player controls and attributes
const player = document.querySelector('.player');
const playlistsMenu = document.querySelector('#playlists-menu ul');
const playerPlaylist = document.querySelector('.player .player-playlist');
const playButton = document.querySelector('.player-play-btn');
const playIcon = playButton.querySelector('.player-icon-play');
const pauseIcon = playButton.querySelector('.player-icon-pause');
const volumeButton = document.querySelector('.player-volume-btn');
const muteIcon = volumeButton.querySelector('.player-icon-mute');
const unmuteIcon = volumeButton.querySelector('.player-icon-unmute');
const progress = document.querySelector('.player-progress');
const progressFilled = document.querySelector('.player-progress-filled');
const playerCurrentTime = document.querySelector('.player-time-current');
const playerDuration = document.querySelector('.player-time-duration');
const volumeControl = document.querySelector('.player-volume');
const nextButton = document.querySelector('.player-next-btn');
const prevButton = document.querySelector('.player-prev-btn');
const playerOptionsButton = document.querySelector('.player-options-btn');
const playerOptionsMenu = document.querySelector('.player-options-menu');
const downloadButton = document.querySelector('#player-download-btn');
const playerSpeedButtons = document.querySelectorAll('#speed-options > div');

window.addEventListener(
  'load',
  () => {
    // Setup listener for each button has class "init-audio-player"
    // So after click on any button has this class, the audio player will start automatically
    initAudioPlayerByButton();

    // Load all playlists menu
    initPlaylistsMenu();

    // Init the player controls and functionality
    initPlayerControllButtons();

    // Set times after page load
    setTimes();

    // Display currentTime and duration properties in real time
    /**
     *
     */
    function setTimes() {
      if (audioElement.currentTime && !isNaN(audioElement.currentTime)) {
        playerCurrentTime.textContent = getDurationInMinutes(new Date(audioElement.currentTime * 1000).toISOString().substr(11, 8));
      }
      if (audioElement.duration && !isNaN(audioElement.duration)) {
        playerDuration.textContent = getDurationInMinutes(new Date(audioElement.duration * 1000).toISOString().substr(11, 8));
      }
    }

    // Update player timeline progress visually
    /**
     *
     */
    function progressUpdate() {
      const percent = (audioElement.currentTime / audioElement.duration) * 100;
      progressFilled.style.flexBasis = `${percent}%`;
    }

    // Scrub player timeline to skip forward and back on click for easier UX
    /**
     * @param event
     */
    function scrub(event) {
      const scrubTime = (event.offsetX / progress.offsetWidth) * audioElement.duration;
      audioElement.currentTime = scrubTime;
    }

    // Convert duration format from hh:mm:ss to mm:ss
    /**
     * @param duration
     */
    function getDurationInMinutes(duration) {
      const timeParts = duration.split(':');
      const minutes = String(+timeParts[0] * 60 + +timeParts[1]).padStart(2, '0');
      const seconds = timeParts[2];
      const newDuration = `${minutes}:${seconds}`;
      return newDuration;
    }

    /**
     *
     */
    function initPlaylistsMenu() {
      playlistsMenu.innerHTML = '';

      // inject playlists into UI
      playlistsData.forEach((el) => {
        const menuItem = document.createElement('li');
        menuItem.setAttribute('title', el.title);
        menuItem.innerHTML = `<p>${el.title}</p>`;
        playlistsMenu.appendChild(menuItem);
      });

      playlistsMenu.querySelectorAll('li').forEach((el, idx) => {
        el.addEventListener('click', (e) => {
          playlistsMenu.querySelectorAll('li').forEach((elem) => elem.classList.remove('selected'));
          e.currentTarget.classList.add('selected');
          loadPlaylist(idx);
        });
      });

      if (playlistsData.length) {
        loadPlaylist(0);
      }
    }

    /**
     * @param idx
     */
    function loadPlaylist(idx) {
      // Set selected playlist
      const selectedPlaylist = playlistsData[idx];
      selectedList = selectedPlaylist;
      // set playlist item as selected
      playlistsMenu.querySelectorAll('li')[idx].classList.add('selected');

      // show selected playlist info
      player.querySelector('.playlist-info h2').innerHTML = selectedPlaylist.title;
      player.querySelector('.playlist-info p').innerHTML = selectedPlaylist.description;

      // if playlist is empty, then hide the player.
      playerPlaylist.querySelector('.player-playlist-items').innerHTML = '';
      if (!selectedPlaylist.tracks.length) {
        player.querySelectorAll('.player-track-meta, .player-controls, .player-playlist').forEach((el) => el.classList.add('hidden'));
        return;
      }

      // Load playlist tracks into player
      selectedPlaylist.tracks.forEach((track, idx) => {
        const trackItem = document.createElement('li');
        trackItem.classList.add('player-playlist-item');

        // set the 1st track as selected
        if (idx == 0) {
          loadTrack(track, false);
        }

        trackItem.innerHTML = `
            <div class="item-order">${idx + 1}</div>
            <div class="item-title">${track.title}</div>
            <div class="item-duration">00:00</div>
            `;
        playerPlaylist.querySelector('.player-playlist-items').appendChild(trackItem);

        // calculate duration for each track in the playlist
        getDuration(track.src).then((length) => {
          const res = getDurationInMinutes(new Date(length * 1000).toISOString().substr(11, 8));
          trackItem.querySelector('.item-duration').innerHTML = res;
        });
      });
    }

    /**
     *
     */
    function initPlayerControllButtons() {
      // Play button toggle
      playButton.addEventListener('click', () => {
        // check if context is in suspended state (autoplay policy)
        // By default browsers won't allow you to autoplay audio.
        // You can overide by finding the AudioContext state and resuming it after a user interaction like a "click" event.
        if (audioCtx?.state === 'suspended') {
          audioCtx?.resume();
        }

        // Play or pause track depending on state
        if (playButton.dataset.playing === 'false') {
          audioElement.play();

          playButton.dataset.playing = 'true';
          playIcon.classList.add('hidden');
          pauseIcon.classList.remove('hidden');
        } else if (playButton.dataset.playing === 'true') {
          audioElement.pause();
          playButton.dataset.playing = 'false';
          pauseIcon.classList.add('hidden');
          playIcon.classList.remove('hidden');
        }
      });

      // Volume button toggle
      const gainNode = audioCtx?.createGain();
      volumeButton.addEventListener('click', () => {
        if (volumeButton.dataset.muted == 'false') {
          // Mute the volume
          gainNode.gain.value = 0;
          volumeButton.dataset.muted = 'true';
          muteIcon.classList.add('hidden');
          unmuteIcon.classList.remove('hidden');
        } else {
          // Unmute the volume
          gainNode.gain.value = 1;
          volumeButton.dataset.muted = 'false';
          muteIcon.classList.remove('hidden');
          unmuteIcon.classList.add('hidden');
        }
      });
      source.connect(gainNode).connect(audioCtx?.destination);

      // Update progress bar and time values as audio plays
      audioElement.addEventListener('timeupdate', () => {
        progressUpdate();
        setTimes();
      });

      // heck if there is any next track, else ends & reset the player
      audioElement.addEventListener('ended', () => {
        if (selectedTrackIdx < selectedList.tracks.length - 1) {
          selectedTrackIdx++;
          const nextTrack = selectedList.tracks[selectedTrackIdx];
          loadTrack(nextTrack, true);
        } else {
          selectedTrackIdx = 0;
          playButton.dataset.playing = 'false';
          pauseIcon.classList.add('hidden');
          playIcon.classList.remove('hidden');
          progressFilled.style.flexBasis = '0%';
          audioElement.currentTime = 0;
          audioElement.duration = audioElement.duration;
        }
      });

      // Bridge the gap between gainNode and AudioContext so we can manipulate volume (gain)
      const volumeControl = document.querySelector('.player-volume');
      volumeControl?.addEventListener('change', () => {
        gainNode.gain.value = volumeControl.value;
      });

      // Next button toggle
      nextButton.addEventListener('click', () => {
        if (selectedTrackIdx < selectedList.tracks.length - 1) {
          selectedTrackIdx++;
        } else {
          selectedTrackIdx = 0;
        }
        const nextTrack = selectedList.tracks[selectedTrackIdx];
        loadTrack(nextTrack, true);
      });

      // Prev button toggle
      prevButton.addEventListener('click', () => {
        if (selectedTrackIdx == 0) {
          selectedTrackIdx = selectedList.tracks.length - 1;
        } else {
          selectedTrackIdx--;
        }
        const prevTrack = selectedList.tracks[selectedTrackIdx];
        loadTrack(prevTrack, true);
      });

      // Tracklist functions
      playerPlaylist.addEventListener('click', function (e) {
        const target = e.target.closest('ul.player-playlist-items li');
        if (target) {
          const selectedTrackIdx = [].indexOf.call(target.parentElement.children, target);
          const selectedTrack = selectedList.tracks[selectedTrackIdx];
          loadTrack(selectedTrack, true);
        }
      });

      let mousedown = false;
      progress.addEventListener('click', scrub);
      progress.addEventListener('mousemove', (e) => mousedown && scrub(e));
      progress.addEventListener('mousedown', () => (mousedown = true));
      progress.addEventListener('mouseup', () => (mousedown = false));

      // Player options button
      playerOptionsButton.addEventListener('click', () => {
        playerOptionsMenu.classList.toggle('hidden');
      });

      // Player speed buttons
      playerSpeedButtons.forEach((speedBtn) => [
        speedBtn.addEventListener('click', (e) => {
          audioElement.playbackRate = +e.currentTarget.dataset.speed;
        }),
      ]);
    }

    /**
     * @param track
     * @param autoplay
     */
    function loadTrack(track, autoplay = false) {
      const idx = selectedList.tracks.findIndex((el) => el.title == track.title);

      // reset audio player
      audioElement.pause();
      playButton.dataset.playing = 'false';
      playIcon.classList.remove('hidden');
      pauseIcon.classList.add('hidden');

      // set track url
      audioElement.src = track.src;
      downloadButton.setAttribute('href', track.src);
      if (!source) {
        source = audioContext.createMediaElementSource(audioElement);
        analyser = audioContext.createAnalyser();
        source.connect(analyser);
        analyser.connect(audioContext.destination);
      }
      // set track data
      player.querySelector('.player-track-meta .player-playlist-item-order').innerHTML = `#${idx + 1}`;
      player.querySelector('.player-track-meta .player-playlist-item-title').innerHTML = `${track.title}`;

      // Mark track as selected
      setTimeout(() => {
        playerPlaylist.querySelectorAll('.player-playlist-items .player-playlist-item').forEach((el) => el.classList.remove('selected'));
        playerPlaylist.querySelectorAll('.player-playlist-items .player-playlist-item')[idx].classList.add('selected');
      }, 200);

      // Autoplay track
      if (autoplay) {
        if (audioCtx?.state === 'suspended') {
          audioCtx?.resume();
        }
        audioElement.play();
        playButton.dataset.playing = 'true';
        playIcon.classList.add('hidden');
        pauseIcon.classList.remove('hidden');
      }
    }

    /**
     * @param src
     */
    function getDuration(src) {
      return new Promise((resolve) => {
        const audio = new Audio();
        /**
         *
         */
        audio.onloadedmetadata = () => {
          resolve(audio.duration);
        };
        audio.src = src;
      });
    }

    /**
     *
     */
    function initAudioPlayerByButton() {
      Array.from(document.querySelectorAll('.init-audio-player')).forEach((btn) => {
        btn.addEventListener('click', () => {
          const audioPlayerElem = document.querySelector('#audio-player');
          if (audioPlayerElem) {
            audioPlayerElem.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });

            if (playlistsData.length) {
              if (playlistsData[0].tracks.length) {
                playlistsMenu.querySelector('li').classList.remove('selected');
                loadPlaylist(playlistsData[0].tracks.length);
                playButton.click();
              }
            }
          }
        });
      });
    }
  },
  false
);
